import {HIDE_MODAL, SHOW_MODAL} from '../types/Modal';
import {COMPLAINT_POSITIONS_ADD_COMPLAINT_POSITION} from '../types/ComplaintPositions';
import * as pageTypes from '../types/Page';

const INITIAL_STATE = { 
    modalProps: {},
    modalType: null
};

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case HIDE_MODAL:
        case COMPLAINT_POSITIONS_ADD_COMPLAINT_POSITION:
            return INITIAL_STATE;
        case SHOW_MODAL:
            return {
                modalType: action.modalType,
                modalProps: action.modalProps
            };
        case pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case pageTypes.PAGE_GO_TO_START_PAGE: 
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return INITIAL_STATE;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Modal.js